export var CMSPageType;
(function (CMSPageType) {
    CMSPageType["NotFound"] = "404";
})(CMSPageType || (CMSPageType = {}));
var CDN_BASE_URL = 'https://cdn1.home24.net';
var removeBackSlashes = function (imageName) { return imageName.replace('/', ''); };
export var getImageURLForCDN = function (service, height, width, imageName, format) {
    if (format === void 0) { format = 'png'; }
    var dimension = height + "x" + width;
    var formattedImageName = removeBackSlashes(imageName);
    return CDN_BASE_URL + "/images/media/catalog/" + service + "/" + dimension + "/" + format + "/" + formattedImageName;
};
export var transformOriginalImageUrl = function (url, width, height) { return url.replace('/original/', "/" + width + "x" + height + "/"); };
var getAllPixelRatioImgSizes = function (url, size) { return ({
    x1: transformOriginalImageUrl(url, size, size),
    x2: transformOriginalImageUrl(url, 2 * size, 2 * size),
    x3: transformOriginalImageUrl(url, 3 * size, 3 * size),
}); };
export var urlToLazyImageProps = function (url, _a) {
    var _b = _a.thumbnail, thumbnail = _b === void 0 ? 16 : _b, mobile = _a.mobile, tablet = _a.tablet, desktop = _a.desktop, large_desktop = _a.large_desktop;
    return ({
        thumbnail: transformOriginalImageUrl(url, thumbnail, thumbnail),
        mobile: getAllPixelRatioImgSizes(url, mobile),
        tablet: getAllPixelRatioImgSizes(url, tablet),
        desktop: getAllPixelRatioImgSizes(url, desktop),
        large_desktop: getAllPixelRatioImgSizes(url, large_desktop),
    });
};
export var getCMSPageImageUrl = function (page, filename) {
    return CDN_BASE_URL + "/static/media/om/img/cms/page/" + page + "/" + filename;
};
